import { DocumentImageSize, DocumentTypeCode } from '@/publicSearch/constants';
import { logError } from '@/lib/logger';

export async function getEntityImage(
  entityGuid: string,
  documentType: DocumentTypeCode,
  size: DocumentImageSize,
  orgId: string,
): Promise<Blob> {
  const headers: Record<string, string> = {
    'X-Organisation-Id': orgId,
    'X-Society-Id': orgId,
  };
  const params = new URLSearchParams({
    entityId: entityGuid,
    documentType: documentType.toString(),
    size,
  });

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/Document/GetImageByEntityId?${params}`,
    {
      method: 'GET',
      headers,
      mode: 'cors',
      credentials: 'include',
    },
  ).catch((error) => logError('Failed to fetch entity image', error));

  if (!response?.ok) {
    throw new Error(`Failed to load entity image: ${response?.status}`);
  }

  return response.blob();
}

/**
 * Fetches a document image from a URL with X-Society-Id header.
 * Uses a same-origin API proxy to avoid CORS (proxy sends X-Society-Id server-side).
 */
export async function getDocumentImageByUrl(
  url: string,
  societyId: string,
  token?: string,
): Promise<Blob> {
  const proxyUrl = `/api/document?url=${encodeURIComponent(url)}&societyId=${encodeURIComponent(societyId)}`;
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const response = await fetch(proxyUrl, {
    method: 'GET',
    credentials: 'include',
    headers,
  }).catch((error) => logError('Failed to fetch document image by URL', error));

  if (!response?.ok) {
    throw new Error(`Failed to load image: ${response?.status}`);
  }
  return response.blob();
}
